import React from 'react'

export default function SentIcon() {
  return (

<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512">
<path d="M2 8.5L5 11.5L14 4.5" stroke="#8696A0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}
